import { PureQueryOptions } from 'apollo-client';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import addProjectMutation from '../../mutations/addProject';
import bookshopsQuery from '../../queries/bookshops';
import { ViewerContext } from '../../types/viewer_context';

@Component({ components: {} })
export default class ProjectEditor extends Vue {
  @Getter public viewerContext!: ViewerContext;
  @Prop() public refetch!: PureQueryOptions;

  public bookshopsQuery = bookshopsQuery;

  public name = '';
  public goal = 'IMPROVE_CATALOG';
  public keywords: string[] = [];
  public budget = '';

  public goalOptions: any = [];

  public invitedBookshops = [];
  public invitedBookshopOptions = [
    { value: 'bookshop-abc', text: 'Bookshop ABC' },
  ];

  public async mounted(): Promise<void> {
    this.goalOptions = [
      {
        text: this.$t(
          'components.library.project_editor.goal_option_improve_catalog'
        ),
        value: 'IMPROVE_CATALOG',
      },
      {
        text: this.$t(
          'components.library.project_editor.goal_option_particular_category'
        ),
        value: 'PARTICULAR_CATEGORY',
      },
      {
        text: this.$t(
          'components.library.project_editor.goal_option_new_releases'
        ),
        value: 'NEW_RELEASES',
      },
    ];

    //const bookshopsQueryResults = await this.$apollo.query({
    //			query: bookshopsQuery,
    //	});
    //this.invitedBookshopOptions = bookshopsQueryResults.data;
    //console.log('inivited bookshop options');
    //console.log(this.invitedBookshopOptions);
  }

  public okEnabled(): boolean {
    return this.name !== '' && this.invitedBookshops.length > 0;
  }

  public reset(): void {
    this.invitedBookshops = [];
    this.name = '';
    this.budget = '';
    this.goal = 'IMPROVE_CATALOG';
    this.keywords = [];
  }

  public show(): void {
    this.reset();
    this.getDialog().show();
  }

  public async handleOk(): Promise<void> {
    const loader = this.$loading.show();
    try {
      await this.$apollo.mutate({
        mutation: addProjectMutation,
        variables: {
          name: this.name,
          budget: parseInt(this.budget, 10),
          goal: this.goal,
          institutionId: this.viewerContext.institutionId,
          keywords: this.keywords,
          invitedBookshop: this.invitedBookshops[0],
        },
        refetchQueries: [this.refetch],
      });
      this.$emit('projectCreated');
    } finally {
      loader.hide();
    }
  }

  private getDialog() {
    return this.$refs.newProjectDialog as any;
  }
}
